import React, { Component } from "react";

class Text extends Component {
    render() {
        let { as: Component, theme, className, ...rest } = this.props;
        Component = Component || "p";
        className = typeof className === "string" ? " " + className : "";
        return <Component tabIndex={0} className={`Text${className}`} {...rest} style={this.props.style || {}} />;
    }
}

export default Text;
